import React from "react";
import { Metric } from "@linkfluence/models/metric";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";

export default function SharedCardsSubtitleBubbleMetric({
  metric,
}: {
  metric: Metric;
}) {
  const locale = useCurrentUserLocale();
  return <>{tr(locale, "CUSTOM_PAGES.WIDGET.BUBBLES_SIZE." + metric)}</>;
}
